import {RegistroEntrenador, RegistroEntrenadorJSON } from '../RegistroEntrenador/RegistroEntrenador';
export interface RegistroEntrenadorTituloJSON {
    ret_id: string;
    ret_reid: string;
    ret_titulo: string;
    ret_otorgado_por: string;
    ret_docente: boolean;
    ret_anio_egreso: number | null;
    ret_imagen_titulo: File | null;
}

export class RegistroEntrenadorTitulo {
    protected constructor(
    private id: string,
    private reid: string,
    private titulo: string,
    private otorgadoPor: string,
    private docente: boolean,
    private anioEgreso: number | null,
    private imagenTitulo: File | null) {}

    static createFrom( id: string,
    reid: string,
    titulo: string,
    otorgadoPor: string,
    docente: boolean,
    anioEgreso: number | null,
    imagenTitulo: File | null) {
        return new this( id,
        reid,
        titulo,
        otorgadoPor,
        docente,
        anioEgreso,
        imagenTitulo)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: RegistroEntrenadorTitulo) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: RegistroEntrenadorTituloJSON) {
        return RegistroEntrenadorTitulo.createFrom( entity.ret_id,
        entity.ret_reid,
        entity.ret_titulo,
        entity.ret_otorgado_por,
        entity.ret_docente,
        entity.ret_anio_egreso,
        entity.ret_imagen_titulo)
    }

    toJSON(): RegistroEntrenadorTituloJSON {
        return {
            ret_id: this.getId(),
            ret_reid: this.getReid(),
            ret_titulo: this.getTitulo(),
            ret_otorgado_por: this.getOtorgadoPor(),
            ret_docente: this.getDocente(),
            ret_anio_egreso: this.getAnioEgreso(),
            ret_imagen_titulo: this.getImagenTitulo()
        }

    }

    getId(): string { return this.id; }

    getReid(): string { return this.reid; }

    getTitulo(): string { return this.titulo; }

    getOtorgadoPor(): string { return this.otorgadoPor; }

    getDocente(): boolean { return this.docente; }

    getAnioEgreso(): number | null { return this.anioEgreso; }

    getImagenTitulo(): File | null { return this.imagenTitulo; }


}

